import React, {ChangeEvent, FC, useEffect, useState} from 'react';
import classNames from 'classnames';
import {AsyncPaginate} from 'react-select-async-paginate';
import { api } from '@/api';
import styles from '../../styles/index.module.scss';
import {styleMultiSelectUser} from '../../../../apps/CreateTask/const';

interface IMultiSelect {
    value?: any;
    onChange: (e: Array<Record<string, any>> | ChangeEvent<any>) => void;
    className?: string,
    disable?: boolean
}

const SelectFindOut: FC<IMultiSelect> = ({value, onChange, className,disable}) => {
    const [values, setValue] = useState<any>(value);

    const loadOptions = async () => {

        const { results } = await api.user.getSourceTraffic();

        const options = results.map((el) => {
            if (value && (value === el.id)) {
                setValue({
                    value: el.id,
                    label: el.title,
                })
            }
            return {
                value: el.id,
                label: el.title,
            }
        })
        return {
            options
        }
    }
    const addValue = async () => {
        const response = await api.user.getSourceInfoTraffic(value);
        setValue({
            value: response.id,
            label: response.title,
        })
    }

    useEffect(() => {
        if (typeof value === 'number') {
            addValue()
        }
    }, [value])

    return (
        <AsyncPaginate
            aria-labelledby="label-users"
            name="source-traffic"
            value={values}
            isDisabled={disable}
            className={classNames(styles['item-select'], className)}
            onChange={(e:any)=>{
                setValue(e);
                onChange(e);
            }}
            isClearable={false}
            placeholder='Выберите'
            loadOptions={loadOptions}
            styles={styleMultiSelectUser}
            noOptionsMessage={() => 'Ничего не найдено'}
            loadingMessage={() => 'Поиск...'}
        />
    );
};

export default SelectFindOut;